<template>
  <div class="contractTempManage">
    <div class="whole_company_from">
      <el-form ref="searchForm" :model="searchForm">
        <QS-search maxLine="2" ref="BLM-search">
          <!-- 内容区域-->
          <el-form-item prop="name" label="合同模板名称">
            <el-select
              v-model="searchForm.name"
              placeholder="请输入合同模板名称"
              clearable
              filterable
              remote
            >
              <el-option
                v-for="item in selectData"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="state" label="合同模板状态">
            <el-select
              v-model="searchForm.state"
              placeholder="请选择合同模板状态"
            >
              <el-option
                v-for="item in typeList"
                :label="item.title"
                :value="item.id"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- 按钮区域，slot方式，各个按钮要单独用item包裹-->
          <template slot="moreBtn">
            <el-form-item>
              <el-button
                :loading="oLading.search"
                size="small"
                type="primary"
                @click="search"
              >
                查询
              </el-button>
            </el-form-item>
            <el-form-item>
              <el-button size="small" @click="reset">重置</el-button>
            </el-form-item>
          </template>
        </QS-search>
      </el-form>
    </div>
    <el-button
      v-if="addContract"
      @click="linkToAddTmp"
      type="primary"
      size="small"
    >
      新增合同模板
    </el-button>
    <div>
      <!-- 列表 -->
      <QS-common-table
        :data="tableData"
        :columns="columns"
        :pagination="paginationData"
        @change="paginationChange"
      >
      </QS-common-table>
    </div>

    <!------启用/禁用弹框------>
    <dialogWrap v-model="oShow.startStop" title="提示" width="400px">
      {{ startStoTitle }}
      <template slot="footer">
        <el-button size="small" @click="cancelFn">取消</el-button>
        <el-button
          :loading="oLading.state"
          @click="submitUpdateHandle(1)"
          v-if="startStoType === 'enable'"
          type="primary"
          size="small"
        >
          启用
        </el-button>
        <el-button
          :loading="oLading.state"
          @click="submitUpdateHandle(0)"
          v-if="startStoType === 'disable'"
          type="primary"
          size="small"
        >
          禁用
        </el-button>
      </template>
    </dialogWrap>
  </div>
</template>

<script>
import {
  tableColumn,
  GROUP_CONTRACT_TEMPLATE_EDIT,
  GROUP_CONTRACT_TEMPLATE_PREVIEW,
  GROUP_CONTRACT_TEMPLATE_ENABLE,
  GROUP_CONTRACT_TEMPLATE_CREATE,
  ADD_GROUP_CONTRACT_TEMPLATE_PATH,
  EDIT_GROUP_CONTRACT_TEMPLATE_PATH,
  storageKeyAdd,
  storageTitleKeyAdd,
  storageKeyEdit,
  storageTitleKeyEdit,
} from './config.js'
// eslint-disable-next-line import/no-cycle
import {
  contractTmpList,
  contractTmpUpdateState,
} from '@/api/domain/carsService'
import { clearLocalStorage } from '@/utils/cache'

export default {
  name: 'contractTempManage',
  data() {
    return {
      oLading: {
        search: false,
        state: false,
      },
      selectData: [],
      oShow: {
        startStop: false,
        // add: false,
      },
      searchForm: {
        name: '',
        state: '',
      },
      startStoTitle: '是否启用该合同模板？',
      startStoType: 'enable',
      typeList: [
        {
          title: '全部',
          id: '',
        },
        {
          title: '启用',
          id: 1,
        },
        {
          title: '禁用',
          id: 0,
        },
      ],
      tableData: [],
      stateObj: {
        id: '',
        state: '',
      },
      paginationData: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      storageKeyAdd,
      storageTitleKeyAdd,
      storageKeyEdit,
      storageTitleKeyEdit,
    }
  },
  computed: {
    canPreview() {
      return this.judgePermission(GROUP_CONTRACT_TEMPLATE_PREVIEW)
    },
    canEdit() {
      return this.judgePermission(GROUP_CONTRACT_TEMPLATE_EDIT)
    },
    canDisable() {
      return this.judgePermission(GROUP_CONTRACT_TEMPLATE_ENABLE)
    },
    columns() {
      return [...tableColumn]?.map((item) => ({ ...item, getOperateList: item.name === 'operate' ? this.buildOptButton : item.getOperateList }))
    },
    addContract() {
      return this.judgePermission(GROUP_CONTRACT_TEMPLATE_CREATE)
    },
  },
  mounted() {
    this.searchForm.dimension = 1
    this.loadData()
    this.loadSelectData()
    this.$refs['BLM-search'].searchMoreClick()
  },
  methods: {
    // 渲染table 行内按钮
    buildOptButton({ row }) {
      const btns = []
      if (this.canPreview) {
        btns.push({
          name: 'preview',
          label: '预览',
          action: () => this.pre(row),
        })
      }

      if (this.canEdit && !row.isDefault) {
        btns.push({
          name: 'edit',
          label: '编辑',
          permission: this.canEdit,
          action: () => this.editHandle(row),
        })
      }

      btns.push({
        name: 'copy',
        label: '复制',
        action: () => this.copy(row),
      })

      if (this.canDisable) {
        btns.push({
          name: Number(row.state) === 0 ? 'enable' : 'disable',
          label: Number(row.state) === 0 ? '启用' : '禁用',
          action: () => this.handleEnableAndDisable(row),
        })
      }

      return btns
    },
    // 控制开启 关闭
    handleEnableAndDisable(row) {
      if (Number(row.state) === 0) {
        this.startStopHandle('enable', row)
      }
      if (Number(row.state) === 1) {
        this.startStopHandle('disable', row)
      }
    },
    pre(row) {
      window.open(`/preview?templateId=${row.id}`, '_blank')
    },
    // 获取列表
    async loadData() {
      this.oLading.search = true
      try {
        const { code, data } = await contractTmpList({
          ...this.searchForm,
          pageNum: this.paginationData.pageNum,
          pageSize: this.paginationData.pageSize,
        })
        this.oLading.search = false
        if (code === 1) {
          this.paginationData.total = data.totalNum
          this.tableData = data.items
        }
      } catch (error) {
        this.oLading.search = false
      }
    },
    search() {
      this.paginationData.pageNum = 1
      this.paginationChange({
        pagination: this.paginationData,
      })
    },

    // 启用禁用弹窗
    startStopHandle(type, row) {
      if (type === 'enable') {
        this.startStoTitle = '是否启用该合同模板？'
        this.startStoType = 'enable'
        this.stateObj = {
          id: row.id, // 公司id
          state: 1, // 公司状态0启用 1禁用
        }
      }
      if (type === 'disable') {
        this.startStoTitle = '是否禁用该合同模板？'
        this.startStoType = 'disable'
        this.stateObj = {
          id: row.id, // 公司id
          state: 0, // 公司状态0启用 1禁用
        }
      }
      this.oShow.startStop = true
    },
    // 提交更新状态
    submitUpdateHandle() {
      this.oLading.state = true
      contractTmpUpdateState(this.stateObj)
        .then((res) => {
          if (res?.code === 1) {
            this.loadData()
            this.$message.success('操作成功')
          }
        })
        .catch((error) => {
          if (error.code === 22050) {
            this.$confirm(
              '有正在使用该合同模板的租赁方案，请修改租赁方案后重试',
              '合同模板禁用提示',
              {
                confirmButtonText: '查看租赁方案列表',
                cancelButtonText: '取消',
                type: 'warning',
              },
            ).then(() => {
              this.$router.push({
                path: '/car_to_lease/leaseScheme/list',
                query: {
                  templateId: this.stateObj.id,
                  active: 'group',
                },
              })
            })
          }
        })
        .finally(() => {
          this.oLading.state = false
          this.cancelFn()
        })
    },
    // 分页事件
    paginationChange(payload) {
      const { pagination } = payload
      this.paginationData.pageSize = pagination.pageSize
      this.paginationData.pageNum = pagination.pageNum
      this.loadData()
    },
    cancelFn() {
      this.oShow.startStop = false
    },

    // 跳转合同模板新增
    linkToAddTmp(isCopy = false, id) {
      const path = ADD_GROUP_CONTRACT_TEMPLATE_PATH
      clearLocalStorage(this.storageKeyAdd)
      clearLocalStorage(this.storageTitleKeyAdd)
      this.$router.push({
        path,
        query: {
          addFlag: true,
          isCopy,
          id,
        },
      })
    },

    copy(row) {
      this.linkToAddTmp(true, row.id)
    },

    // 跳转合同模板编辑
    editHandle(row) {
      const path = EDIT_GROUP_CONTRACT_TEMPLATE_PATH
      clearLocalStorage(this.storageKeyEdit)
      clearLocalStorage(this.storageTitleKeyEdit)
      this.$router.push({
        path,
        query: {
          id: row.id,
          editFlag: true,
        },
      })
    },
    reset() {
      this.$refs.searchForm.resetFields()
      this.search()
    },
    // 获取合同名称筛选项
    async loadSelectData() {
      const { code, data } = await contractTmpList({
        name: '',
        state: '',
      })
      if (code === 1) {
        this.selectData = data.items
      }
    },
  },
}
</script>
